import React from 'react';

import { Empty } from 'antd';

type OrganizationEmptyStateVariant = 'not-enabled' | 'no-children';

const DESCRIPTIONS: Record<OrganizationEmptyStateVariant, string> = {
  'not-enabled': 'Master Account is not enabled for this partner',
  'no-children': 'No child organizations yet',
};

interface IOrganizationEmptyStateProps {
  variant: OrganizationEmptyStateVariant;
}

export const OrganizationEmptyState = ({
  variant,
}: IOrganizationEmptyStateProps) => (
  <Empty
    data-testid="organization-empty-state"
    description={DESCRIPTIONS[variant]}
  />
);
